import React from 'react';
import { HintContainer, HintText } from './ApprovalRulesBypassedHint.styles';
const ApprovalRulesBypassedHint = ({ bypasserName }) => {
    const text = `${bypasserName} bypassed the approval rules`;
    return (React.createElement(HintContainer, null,
        React.createElement(HintText, null, text)));
};
export default ApprovalRulesBypassedHint;
